/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
'use strict';

/**
 * Filter module related to salesforce conversions.
 */
angular
  .module('filters.salesforce', [])
  /**
   * Filter used to convert a 15 character SF id to an 18 character id.
   * Logic taken from http://www.adminbooster.com/tool/15to18.
   *
   * @returns {String} - The converted id or the passed value if it is not a 15 char string.
   */
  .filter('15To18', function () {
    return function (id) {
      id = id || '';

      if (id.length !== 15 || !_.isString(id)) {
        return id;
      }
      var sfPostfix = '';
      for (var i = 0; i < 3; i++) {
        var chatToAdd = 0;
        for (var j = 0; j < 5; j++) {
          var charLookup = id.charAt(i * 5 + j);
          if (charLookup >= 'A' && charLookup <= 'Z') {
            // Ignore jshint left shift check as left shift is needed here.
            /* jshint -W016 */
            chatToAdd += 1 << j;
            /* jshint +W016 */
          }
        }
        sfPostfix += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ012345'.charAt(chatToAdd);
      }
      id = id + sfPostfix;

      return id;
    };
  });
